var render = function (_h,_vm) {var _c=_vm._c;return _c('div',_vm._b({staticClass:"field",class:[
    _vm.data.staticClass,
    {
      'field--invalid': _vm.$options.hasError(_vm.props.error),
    }
  ],style:(_vm.data.staticStyle)},'div',_vm.data.attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }